export default "__VITE_ASSET__BVAzKaOt__"